import { useAtomValue, useSetAtom } from 'jotai';
import { useMemo } from 'react';

import { Dropdown, Stack } from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';

import {
	registrationStateFilterAtom,
	updateRegistrationStateFilterAtom,
} from '../../atoms/ordersAtoms';
import { useFilterFacetCounts } from '../../hooks/useFilterFacetCounts';

/**
 * FiltersDrawerRegistrationSection component that provides registration-based filtering options
 * wrapped in an accordion
 */
export function FiltersDrawerRegistrationSection() {
	const registrationState = useAtomValue(registrationStateFilterAtom);

	const setRegistrationState = useSetAtom(updateRegistrationStateFilterAtom);

	// Get dynamic facet counts from the search response
	const { registrationStateCounts } = useFilterFacetCounts();

	// Build registration state dropdown options with dynamic counts from facets
	// Sort alphabetically for consistent ordering
	const registrationStateOptions = useMemo(() => {
		const entries = Object.entries(registrationStateCounts)
			.map(([state, count]) => ({
				id: state,
				label: `${state} (${count})`,
			}))
			.sort((a, b) => a.id.localeCompare(b.id));

		return entries.map((entry) => ({
			id: entry.id,
			label: entry.label,
		}));
	}, [registrationStateCounts]);

	return (
		<AccordionSection title='Registration'>
			<Stack itemsSpacing='8'>
				<Dropdown
					label='Registration state'
					options={registrationStateOptions}
					value={registrationState}
					onSelectionChange={(value) => setRegistrationState(value || null)}
					placeholder='Select registration state'
				/>
			</Stack>
		</AccordionSection>
	);
}
